import axios from "axios";
import { server } from "../api";

// Cross-line (越線) tripwire REST client. Same client shape/error envelope as
// the neighbouring IndoorPositioning* modules (IndoorPositioningAlertConfig,
// IndoorPositioningStations): every call resolves (never rejects) with either
// the backend's `{code, data, message}` envelope or a synthesized 500 one, so
// callers only ever branch on `response.code`.
//
// Tripwire JSON is snake_case end-to-end (matches the backend contract in
// controller/indoor_positioning_tripwire_api.py), unlike the camelCase
// `/live/*` endpoints -- deliberately not normalized here so the wire shape
// stays a 1:1 mirror of what the backend validates and persists.
const IndoorPositioningTripwire = {
  List: async (machineID) => {
    try {
      const response = await axios.get(
        `${server}indoor-positioning/${machineID}/tripwires`,
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "獲取越線警報清單失敗",
          data: null,
        }
      );
    }
  },

  Create: async (machineID, tripwire) => {
    try {
      const response = await axios.post(
        `${server}indoor-positioning/${machineID}/tripwires`,
        tripwire,
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "新增越線警報失敗",
          data: null,
        }
      );
    }
  },

  Update: async (machineID, tripwireId, fields) => {
    try {
      const response = await axios.put(
        `${server}indoor-positioning/${machineID}/tripwires/${tripwireId}`,
        fields,
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "更新越線警報失敗",
          data: null,
        }
      );
    }
  },

  Delete: async (machineID, tripwireId) => {
    try {
      const response = await axios.delete(
        `${server}indoor-positioning/${machineID}/tripwires/${tripwireId}`,
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "刪除越線警報失敗",
          data: null,
        }
      );
    }
  },
};

export default IndoorPositioningTripwire;
